export default "__VITE_ASSET__c287e789__"